var map = {
	"./Microsoft_Excel_2013-2019_logo.svg": 16962,
	"./doc.png": 37084,
	"./excel.png": 14755,
	"./exe.png": 15670,
	"./file.png": 74642,
	"./file1.png": 72177,
	"./file2.png": 51066,
	"./folder.png": 26052,
	"./image.png": 70965,
	"./ppt.png": 41762,
	"./word.png": 6964,
	"./zip.png": 46239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5409;